import styled, { css } from 'styled-components';

import { mediaQuery, CardContainer as UICardContainer } from '@catalyze/ui';

export const cardContainerStyle = css`
    position: relative;
    align-items: flex-start;
    ${mediaQuery(
        2,
        css`
            min-width: 33rem;
            padding: 2rem;
        `
    )}
`;

export const CardContainer = styled(UICardContainer)`
    ${cardContainerStyle}
`;
